import appendQuery from 'append-query'

import { request, ANALYTICS_URL, WEB_API_KEY } from 'shared/api'

const formatDate = (inputDate) => {
    let dd = String(inputDate.getDate()).padStart(2, '0')
    let mm = String(inputDate.getMonth() + 1).padStart(2, '0') // January is 0!
    let yyyy = inputDate.getFullYear()
    return yyyy + '-' + mm + '-' + dd
}

const contentTypes = {
    'GIFs & Stickers': 'gif,sticker',
    GIFs: 'gif',
    Stickers: 'sticker',
    Stories: 'story',
    Clips: 'clip',
}

export type LeaderboardItem = {
    viewCount: number
    contentType: string
    contentId: string
}

export type AggregationData = {
    viewCount: number
    uploadCount: number
}

type TopTermItem = {
    userId?: string
    gifId: string
    term: string
    clickCount: number
    impressionCount: number
    ctr: number
}

export const getLeaderboard = (token, contentType, dateRange) => {
    let startDate = formatDate(dateRange[0])
    let endDate = formatDate(dateRange[1])

    const url = appendQuery(`${ANALYTICS_URL}leaderboard/`, {
        api_key: WEB_API_KEY,
        start_dt: startDate,
        end_dt: endDate,
        content_type: contentTypes[contentType],
        limit: 50,
    })

    return request(
        url,
        {
            headers: {},
            credentials: 'omit', // prevent sending cookies in the request (this was overriding the provided token)
        },
        token
    ) as Promise<LeaderboardItem[]>
}

export const getAggregations = (token, contentType, dateRange) => {
    let startDate = formatDate(dateRange[0])
    let endDate = formatDate(dateRange[1])

    const url = appendQuery(`${ANALYTICS_URL}aggregations/`, {
        api_key: WEB_API_KEY,
        start_dt: startDate,
        end_dt: endDate,
        content_type: contentTypes[contentType],
        limit: 50,
    })

    return request(
        url,
        {
            headers: {},
            credentials: 'omit', // prevent sending cookies in the request (this was overriding the provided token)
        },
        token
    ) as Promise<AggregationData>
}

export const getTopTerms = (token, contentType, dateRange, content_id) => {
    let startDate = formatDate(dateRange[0])
    let endDate = formatDate(dateRange[1])

    const params = {
        api_key: WEB_API_KEY,
        start_dt: startDate,
        end_dt: endDate,
        content_type: contentTypes[contentType],
        content_ids: content_id,
    }

    const url = appendQuery(`${ANALYTICS_URL}ctr/`, params, { encodeComponents: false })

    return request(
        url,
        {
            headers: {},
            credentials: 'omit', // prevent sending cookies in the request (this was overriding the provided token)
        },
        token
    ) as Promise<TopTermItem[]>
}

export const getClipStarts = (token, contentType, dateRange, content_id) => {
    let startDate = formatDate(dateRange[0])
    let endDate = formatDate(dateRange[1])

    const params = {
        api_key: WEB_API_KEY,
        start_dt: startDate,
        end_dt: endDate,
        content_type: contentTypes[contentType],
        content_ids: content_id,
    }

    const url = appendQuery(`${ANALYTICS_URL}start_count/`, params, { encodeComponents: false })

    return request(
        url,
        {
            headers: {},
            credentials: 'omit', // prevent sending cookies in the request (this was overriding the provided token)
        },
        token
    ) as Promise<TopTermItem[]>
}

export const getCsvLink = (contentType, dateRange, username) => {
    let startDate = formatDate(dateRange[0])
    let endDate = formatDate(dateRange[1])

    const url = appendQuery(`${ANALYTICS_URL}csv/`, {
        api_key: WEB_API_KEY,
        start_dt: startDate,
        end_dt: endDate,
        content_type: contentTypes[contentType],
        username: username,
    })

    return url as string
}

export const getCsvCtrLink = (contentType, dateRange, username) => {
    if (contentTypes[contentType] === 'clip') {
        return ''
    }

    let startDate = formatDate(dateRange[0])
    let endDate = formatDate(dateRange[1])

    const url = appendQuery(`/api/v2/users/csv-ctr/`, {
        api_key: WEB_API_KEY,
        start_dt: startDate,
        end_dt: endDate,
        content_type: contentTypes[contentType],
        username: username,
    })

    return url as string
}
